export default __webpack_public_path__ + "static/media/2417.3365ed2b.png";